import React, { useState } from "react";
import Carousel from "nuka-carousel";
import bannerData from "./bannerCarouselData.json";
import { useSelector } from "react-redux";
import { useMsal } from "@azure/msal-react";
import {
  isCourseEligible,
  getCoursesGroupedByCategoryAndModule,
} from "utils/foundationUnlock";
import "./BannerCarousel.css";

function DemoCarousel() {
  const IMAGE_SLIDE_INTERVAL = 4000;
  const VIDEO_SLIDE_INTERVAL = 14000;

  const [currentSlide, setCurrentSlide] = useState(0);

  const totalSlides = bannerData.length + 1; // +1 for video slide
  const isVideoSlide = currentSlide === totalSlides - 1;

  const userData = useSelector((state) => state.userDetails.userData?.[0]);
  const { coursesByHub } = useSelector((state) => state.courseDetails);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const userLevel = activeAccount?.idTokenClaims?.jobFamilyDescription;

  const allCompletedEligibleCourses =
    coursesByHub?.flatMap((hub) =>
      (hub.courses || []).filter((course) => course.completionDate)
    ) || [];

  const completedEligibleCount = allCompletedEligibleCourses.length;

  let badgesEarned = 0;

  coursesByHub?.forEach((hub) => {
    const groupedCourses = getCoursesGroupedByCategoryAndModule({
      coursesByHub: [hub],
      userData,
      userLevel,
      hubName: hub.hubName,
    });

    Object.values(groupedCourses).forEach((category) => {
      Object.values(category).forEach((moduleObj) => {
        const mandatoryCourses = moduleObj.Mandatory || [];

        // Badge is earned if all mandatory eligible courses in module are completed
        if (
          mandatoryCourses.length &&
          mandatoryCourses.every((c) => c.completionDate)
        ) {
          badgesEarned += 1; // 1 badge per module
        }
      });
    });
  });

  const totalPoints = allCompletedEligibleCourses.reduce(
    (acc, course) => acc + (course.coursePoints || 0),
    0
  );

  return (
    <Carousel
      autoplay={true}
      autoplayInterval={
        isVideoSlide ? VIDEO_SLIDE_INTERVAL : IMAGE_SLIDE_INTERVAL
      }
      wrapAround={true}
      afterSlide={(index) => setCurrentSlide(index)}
      renderCenterLeftControls={({ previousSlide }) => (
        <button onClick={previousSlide} className="preBtn">
          &lsaquo;
        </button>
      )}
      renderCenterRightControls={({ nextSlide }) => (
        <button onClick={nextSlide} className="nextBtn">
          &rsaquo;
        </button>
      )}
    >
      {bannerData.map((slide) => (
        <div className="nuka-box" key={slide.id}>
          <img
            src={process.env.PUBLIC_URL + slide.image}
            alt="Ignite banner"
            className="banner-img"
          />
          <img
            src={process.env.PUBLIC_URL + slide.unionimg}
            alt="Ignite"
            className="banner-union-img"
            style={{ display: slide.unionimg ? "block" : "none" }}
          />
          <img
            src={process.env.PUBLIC_URL + slide.circleimg}
            alt="Ignite"
            className="banner-circle-img"
            style={{ display: slide.circleimg ? "block" : "none" }}
          />

          <div className="ignite-banner-box">
            <div className="ignite-banner-content">
              <h1 className="banner-main-head">{slide.title}</h1>
              <p className="banner-sub-text">{slide.description}</p>
            </div>

            <div className="banner-sub-content-row">
              <div className="banner-sub-content-img-box">
                <img
                  src={`${process.env.PUBLIC_URL}/Assets/Home/medal-icon.png`}
                  alt="medal"
                  className="medal-icon"
                />
              </div>

              <div className="banner-sub-content-box">
                <p>
                  <span>Points Earned</span>
                </p>
                <p>{totalPoints}</p>
              </div>

              <div className="banner-sub-content-box">
                <p>
                  <span>Badges Earned</span>
                </p>
                <p>{badgesEarned}</p>
              </div>

              <div className="banner-sub-content-box">
                <p>
                  <span>Courses Completed</span>
                </p>
                <p>{completedEligibleCount}</p>
              </div>
            </div>
          </div>
        </div>
      ))}

      <div className="nuka-box" key="video-slide">
        <div className="video-slider-box">
          <video
            src={`${process.env.PUBLIC_URL}/Assets/Home/ignite-banner-video-latest.mp4`}
            autoPlay
            muted
            loop
            className="ignite-banner-video"
          />
        </div>
      </div>
    </Carousel>
  );
}

export default DemoCarousel;
